import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/auth'
import { DataProviderProvider } from '@/providers/DataProviderContext'
import {
  LandingPage,
  LoginPage,
  SignupPage,
  BooksDashboard,
  BookEditor,
  ComponentDemo,
} from '@/pages'
import { ProtectedRoute } from '@/components'

function App() {
  return (
    <AuthProvider>
      <DataProviderProvider>
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />

            {/* Protected routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <BooksDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/editor/:bookId"
              element={
                <ProtectedRoute>
                  <BookEditor />
                </ProtectedRoute>
              }
            />

            {/* Demo route (always accessible) */}
            <Route path="/demo" element={<ComponentDemo />} />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </DataProviderProvider>
    </AuthProvider>
  )
}

export default App
